
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11523',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11523",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.214",
  "data-fetching-client": "static-1.9466",
  "foundations-components": "static-1.7499",
  "foundations-components-legacy": "static-1.524",
  "foundations-theming": "static-1.4197",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7793",
  "hub-http-shared-msw-handlers": "static-1.9451",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11211",
  "I18n": "static-7.1565",
  "jasmine-runner": "static-1.6260",
  "marketplace-storefront-base": "static-1.11583",
  "quartz": "static-1.6717",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16435",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2650",
  "reporting-testing-lib": "static-1.8394",
  "settings-ui-lib": "static-1.12310",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6707",
  "ui-addon-i18n": "static-1.10925",
  "ui-addon-react-router-dom": "static-1.9335",
  "unified-auth": "static-1.190",
  "unified-auth-core-lib": "static-1.471",
  "usage-tracker": "static-1.7119",
  "usage-tracker-core": "static-1.6969",
  "customer-data-property-utils": "static-1.7864",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15378",
  "marketplace-ui-common": "static-1.18903",
  "property-management-iframe": "static-1.12285",
  "quartz-config": "static-1.495",
  "quartz-core": "static-1.5936",
  "quartz-routing": "static-1.147",
  "quick-fetch": "static-1.3724",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4420",
  "ts-schema": "static-1.3891",
  "ui-universal-auth": "static-1.8676",
  "UIComponents": "static-3.8158",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3214",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2994",
  "quartz-webpack": "static-1.2941",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3768",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4625",
  "foundations-theming-specialty": "static-1.1913",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9216",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5161",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1159",
  "ui-fonts": "static-1.473",
  "ui-images": "static-2.1087",
  "bend-plugin-foundations-theming": "static-1.2680",
  "foundations-theming-base": "static-1.3182",
  "stylex": "static-1.27",
  "HeadJS": "static-2.707",
  "hs-test-utils-bend-plugin": "static-1.2904",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4115",
  "ai-components-ui-library": "static-1.8319",
  "ai-rendering-library": "static-1.9264",
  "chirp-fetch": "static-1.1670",
  "connections-embed-lib": "static-1.608",
  "copilot-toolkit": "static-1.10494",
  "laboratory-lib": "static-3.6949",
  "marketplace-embed": "static-1.21454",
  "marketplace-ui-details": "static-1.8799",
  "marketplace-ui-reviews": "static-1.18859",
  "marketplace-ui-tracking": "static-1.13074",
  "sanitize-text": "static-1.7927",
  "ui-addon-video-player": "static-1.8482",
  "usage-tracker-multi": "static-1.5533",
  "usage-tracker-session-replay": "static-1.4805",
  "wootric-nps": "static-1.6770",
  "apollo-link-hub-http": "static-2.4436",
  "immer": "static-1.33",
  "immerable": "static-1.3941",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2385",
  "reporting-data": "static-1.66461",
  "cssUtils": "static-1.727",
  "flux-actions": "static-1.307",
  "HubStyle": "static-2.11519",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9998",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10160",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7109",
  "icons": "static-2.620",
  "marketplace-ui-apps-core": "static-1.17436",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4311",
  "foundations-components-test-utils": "static-1.4982",
  "quartz-i18n": "static-1.392",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3518",
  "customer-data-objects": "static-1.7434",
  "property-translator": "static-1.5201",
  "frontend-preferences-client": "static-1.7712",
  "hs-promise-utils": "static-1.5380",
  "hubspot-apollo-client": "static-1.4668",
  "integrations-error-boundary-lib": "static-1.12793",
  "integrations-tracking-lib": "static-1.5375",
  "native-integrations-shared-strings": "static-1.7575",
  "reselect": "static-2.16",
  "sanitize": "static-1.4262",
  "superstore": "static-1.4558",
  "ui-shepherd-react": "static-3.9932",
  "ai-settings-ui-library": "static-1.7428",
  "hub-http-janus": "static-1.790",
  "hubspotter-http": "static-1.4466",
  "immutable-less": "static-1.4441",
  "marketplace-ui-client-types": "static-1.16310",
  "nav-meta": "static-1.28869",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10024",
  "ui-addon-upgrades": "static-9.17635",
  "inbound-db-properties-service-client": "static-1.3663",
  "property-management-common": "static-1.4572",
  "ui-addon-iframeable": "static-1.8832",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.480",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.392",
  "quartz-head": "static-1.382",
  "quartz-test": "static-1.392",
  "quartz-tracking": "static-1.96",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2933",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20257",
  "ContentUtils": "static-1.67588",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2272",
  "customer-data-filters-ui": "static-1.38866",
  "customer-data-objects-ui-components": "static-1.12793",
  "customer-data-reference-ui-components": "static-1.12930",
  "embedded-academy-lib": "static-1.13473",
  "ExportDialog": "static-6.10175",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40630",
  "reporting-snowflake": "static-1.55079",
  "reporting-ui-components": "static-2.63732",
  "reporting-visualizations": "static-1.58537",
  "ui-addon-teams": "static-1.21224",
  "magpie-lib": "static-1.5381",
  "magpie-types": "static-1.4841",
  "simple-logging-lib": "static-1.2837",
  "navigation-components": "static-1.17232",
  "ai-studio-lib": "static-1.10967",
  "developer-experience-shared-components": "static-1.10251",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7776",
  "ui-tool-access": "static-1.9933",
  "usage-based-billing-components-lib": "static-1.7974",
  "usage-tracker-anonymous": "static-1.5536",
  "usage-tracker-public": "static-1.6930",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3405",
  "persist-promise": "static-1.3493",
  "reference-resolvers": "static-1.7949",
  "ui-extensibility-client-types": "static-1.3733",
  "hubspot-apollo-cache": "static-1.127",
  "universal-page-editor-lib": "static-1.2787",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2157",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4857",
  "purchase-motions-components": "static-1.5465",
  "salesImages": "static-1.520",
  "batch-promise": "static-1.1336",
  "crm-component-utils": "static-1.38455",
  "crm-properties-common-lib": "static-1.5659",
  "framework-data-schema-resolvers": "static-1.6658",
  "reference-resolvers-lite": "static-1.7882",
  "navigation-messaging": "static-1.6559",
  "hubspotter-http-shared-msw-handlers": "static-1.9449",
  "cms-field-types": "static-1.4593",
  "content-icons-ui": "static-1.2149",
  "conversations-skeleton-state": "static-1.7035",
  "crm-message-bus": "static-1.42331",
  "customer-data-filters-ui-msw-helpers": "static-1.21300",
  "customer-data-ui-utilities": "static-1.9612",
  "FormUrlGenerator": "static-2.4518",
  "framework-builder-read-service-client": "static-1.3821",
  "framework-data-schema-quick-fetch": "static-1.6563",
  "multi-account-reference-resolvers": "static-1.760",
  "onboarding-tours": "static-1.16240",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13002",
  "academy-common-lib": "static-1.12933",
  "content-assistance-lib": "static-1.7430",
  "dashboard-lib": "static-1.80582",
  "file-manager-components": "static-1.22855",
  "getting-started-shared-tasks": "static-1.17851",
  "hubspot-prosemirror": "static-1.17575",
  "hubspot-prosemirror-plugins": "static-1.17567",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19451",
  "share-with-third-party-component-lib": "static-1.8479",
  "ui-addon-draggable": "static-3.4553",
  "ui-asset-management-lib": "static-1.10693",
  "ui-business-units-lib": "static-1.8814",
  "user-context": "static-1.4883",
  "growth-payments-core": "static-1.24697",
  "reporting-plugins": "static-1.9968",
  "reporting-reports": "static-1.66139",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.512",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28833",
  "react-codemirror": "static-1.10414",
  "apps-service-types": "static-1.3665",
  "oauth-service-types": "static-1.4029",
  "onboarding-scopes": "static-1.6250",
  "onboarding-tours-client": "static-1.4454",
  "platform-infra-nav-components": "static-1.7480",
  "subscription-experience-data-types": "static-1.14573",
  "crm-record-cards-service-types": "static-1.3440",
  "location-customization-utils-lib": "static-1.8526",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2144",
  "purchase-motions-api": "static-1.5468",
  "signup-constants": "static-1.18363",
  "signup-ui-url-generator": "static-2.7855",
  "trials-service-types": "static-1.3702",
  "card-properties-lib": "static-1.43486",
  "crm-actions": "static-1.6087",
  "crm-cards-data": "static-1.1186",
  "crm-cards-sdk": "static-1.42881",
  "customer-data-properties": "static-1.50769",
  "customer-data-properties-shared-msw-handlers": "static-1.8778",
  "customer-data-tracking": "static-1.6668",
  "conditional-properties-service-client": "static-1.3611",
  "crm-pipelines-api-client-types": "static-1.3953",
  "multi-currency-client-types": "static-1.3505",
  "external-options-client-types": "static-1.3972",
  "react-dnd-compat": "static-1.4409",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5140",
  "growth-onboarding-confetti": "static-1.2858",
  "growth-onboarding-next-action-utils": "static-1.1287",
  "onboarding-tours-utils": "static-1.306",
  "ui-shepherd-tracker": "static-1.7313",
  "academy-service-client": "static-1.3468",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27913",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8172",
  "video-components-external": "static-1.10527",
  "video-data-lib": "static-1.34185",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8356",
  "payment-link-components": "static-1.22911",
  "ui-addon-emoji-picker": "static-1.9676",
  "EmailSignatureEditor": "static-1.23884",
  "viral-links-lib": "static-1.6821",
  "data-token-picker": "static-1.16023",
  "FileManagerLib": "static-1.38495",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5032",
  "getting-started-shared-tasks-store": "static-1.16969",
  "campaign-roi-lib": "static-1.8238",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.177",
  "eligibility-engine-service-types": "static-1.2983",
  "crm_data": "static-4.91178",
  "crm-links": "static-1.6050",
  "customer-data-sidebar": "static-2.45385",
  "enrichment-properties-lib": "static-1.14983",
  "crm-fe-perf": "static-1.22692",
  "calling-global-api": "static-1.63615",
  "calling-internal-common": "static-1.31078",
  "calling-lifecycle-internal": "static-1.64997",
  "calling-lifecycle-messages": "static-1.57291",
  "commerce-products-lib": "static-1.8829",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.465",
  "inbounddb-objects-service-types": "static-1.4037",
  "meetings-icalendar-utils-lib": "static-1.420",
  "object-builder-ui-client": "static-1.47929",
  "pipeline-validation-client-types": "static-1.3774",
  "property-value-citations": "static-1.1383",
  "pulse": "static-1.293",
  "smart-property-lib": "static-1.5865",
  "tiered-pricing": "static-1.811",
  "ui-addon-form-validation": "static-1.10782",
  "growth-onboarding-feedback-components": "static-1.6372",
  "content-media-composition-data-lib": "static-1.11413",
  "content-media-compositions": "static-2.15420",
  "media-bridge-lib": "static-1.18545",
  "commerce-tours-lib": "static-1.5701",
  "growth-onboarding-reliability": "static-1.4874",
  "sales-checkout-service-client": "static-1.3462",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21289",
  "sales-email-signature-service-client": "static-1.3632",
  "audio-components": "static-1.5595",
  "FileManagerCore": "static-1.38354",
  "FileManagerImages": "static-1.36006",
  "video-components": "static-1.12530",
  "crm_universal": "static-1.21642",
  "customer-data-email": "static-1.17651",
  "calling-error-reporting": "static-1.31084",
  "card-payment-highlight-lib": "static-1.36473",
  "card-subscription-highlight-lib": "static-1.38829",
  "commerce-billing-lib": "static-1.18472",
  "commerce-contract-lib": "static-1.11124",
  "customer-data-content": "static-1.26852",
  "invoices-highlight-card-lib": "static-1.53986",
  "orders-highlight-card-lib": "static-1.20841",
  "products-highlight-card-lib": "static-1.17113",
  "project-storage": "static-1.4519",
  "quotes-highlight-card-lib": "static-1.71131",
  "breeze-intelligence-kit": "static-1.5303",
  "crm-source-interpretation-lib": "static-1.5116",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9534",
  "policy-lib": "static-1.6572",
  "shared-worker-versioning": "static-1.10824",
  "calling-usage-tracker": "static-1.6326",
  "voice-sms-access-library": "static-1.211",
  "products-iframe-lib": "static-1.7281",
  "products-ui-components-shared-msw-handlers": "static-1.9833",
  "directed-graph": "static-1.724",
  "event-emitter": "static-1.734",
  "react-tinymce": "static-1.54586",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9597",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53712",
  "tinymce-plugins": "static-1.56826",
  "tinymce-themes": "static-1.55682",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4320",
  "video-embed": "static-1.35019",
  "social-insights-client-types": "static-1.21291",
  "sequences-lib": "static-1.7672",
  "ui-gdpr-components": "static-1.10134",
  "commerce-shared-components-lib": "static-1.17886",
  "commerce-subscription-lib": "static-1.36406",
  "commerce-tools-ui-lib": "static-1.9763",
  "utility-belt": "static-1.2329",
  "payments-enrollment-embed-lib": "static-1.21971",
  "products-ui-components": "static-1.39348",
  "quotes-client-types": "static-1.37219",
  "quotes-ui-lib": "static-1.79850",
  "SalesContentIndexUI": "static-3.8883",
  "accounting-integrations-ui-components": "static-1.6705",
  "invoices-ui-lib": "static-1.54002",
  "commerce-products-api": "static-1.1940",
  "SafeStorage": "static-1.4191",
  "invoices-iframe-lib": "static-1.56060",
  "quotes-modal-lib": "static-1.101807",
  "calling-orchestration-schema": "static-1.34988",
  "sales-views-client-types": "static-1.4079",
  "hub-http-contrib": "static-1.2832",
  "interframe": "static-3.4579",
  "tinymce-data": "static-1.39797",
  "ui-addon-sales-email": "static-1.5001",
  "layout-dnd-components": "static-1.12012",
  "layout-dnd-utils": "static-1.10987",
  "ui-brand-identity-lib": "static-1.13831",
  "NamespacedHubStyle": "static-2.8884",
  "outpost": "static-1.3993",
  "sequences-client-types-lib": "static-1.7529",
  "customer-data-associations": "static-1.7124",
  "framework-data-table": "static-2.11388",
  "customer-data-rte": "static-1.32418",
  "cv-backend-services": "static-1.1500",
  "growth-onboarding-empty-states": "static-1.5347",
  "InboxConnectUtils": "static-4.14194",
  "payments-post-enroll-local-storage-lib": "static-1.4899",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7114",
  "commerce-permissions": "static-1.540",
  "commerce-tax-lib": "static-1.301",
  "property-description-translator": "static-1.3647",
  "FireAlarmUi": "static-1.4318",
  "sales-templates-service-types-lib": "static-1.3979",
  "commerce-analytics-service-client": "static-1.3450",
  "totals-ui-components": "static-1.22969",
  "ContentData": "static-1.67663",
  "layout-data-lib": "static-1.9312",
  "deal-intel-decorators": "static-1.1219",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27687",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3625",
  "advanced-menus-core": "static-1.14796",
  "advanced-menus-lib": "static-1.11772",
  "ui-memberships-settings-lib": "static-1.33396",
  "deal-intel-utils": "static-1.1223",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14795",
  "simple-menus-lib": "static-1.16312"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11523",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.214",
  "data-fetching-client": "/data-fetching-client/static-1.9466",
  "foundations-components": "/foundations-components/static-1.7499",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.524",
  "foundations-theming": "/foundations-theming/static-1.4197",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7793",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9451",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11211",
  "I18n": "/I18n/static-7.1565",
  "jasmine-runner": "/jasmine-runner/static-1.6260",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11583",
  "quartz": "/quartz/static-1.6717",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16435",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2650",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8394",
  "settings-ui-lib": "/settings-ui-lib/static-1.12310",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6707",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10925",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9335",
  "unified-auth": "/unified-auth/static-1.190",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.471",
  "usage-tracker": "/usage-tracker/static-1.7119",
  "usage-tracker-core": "/usage-tracker-core/static-1.6969",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7864",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15378",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18903",
  "property-management-iframe": "/property-management-iframe/static-1.12285",
  "quartz-config": "/quartz-config/static-1.495",
  "quartz-core": "/quartz-core/static-1.5936",
  "quartz-routing": "/quartz-routing/static-1.147",
  "quick-fetch": "/quick-fetch/static-1.3724",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4420",
  "ts-schema": "/ts-schema/static-1.3891",
  "ui-universal-auth": "/ui-universal-auth/static-1.8676",
  "UIComponents": "/UIComponents/static-3.8158",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3214",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2994",
  "quartz-webpack": "/quartz-webpack/static-1.2941",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3768",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4625",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1913",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9216",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5161",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1159",
  "ui-fonts": "/ui-fonts/static-1.473",
  "ui-images": "/ui-images/static-2.1087",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2680",
  "foundations-theming-base": "/foundations-theming-base/static-1.3182",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.707",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2904",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4115",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8319",
  "ai-rendering-library": "/ai-rendering-library/static-1.9264",
  "chirp-fetch": "/chirp-fetch/static-1.1670",
  "connections-embed-lib": "/connections-embed-lib/static-1.608",
  "copilot-toolkit": "/copilot-toolkit/static-1.10494",
  "laboratory-lib": "/laboratory-lib/static-3.6949",
  "marketplace-embed": "/marketplace-embed/static-1.21454",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8799",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18859",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13074",
  "sanitize-text": "/sanitize-text/static-1.7927",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8482",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5533",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4805",
  "wootric-nps": "/wootric-nps/static-1.6770",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4436",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3941",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "reporting-data": "/reporting-data/static-1.66461",
  "cssUtils": "/cssUtils/static-1.727",
  "flux-actions": "/flux-actions/static-1.307",
  "HubStyle": "/HubStyle/static-2.11519",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9998",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10160",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7109",
  "icons": "/icons/static-2.620",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17436",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4311",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4982",
  "quartz-i18n": "/quartz-i18n/static-1.392",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3518",
  "customer-data-objects": "/customer-data-objects/static-1.7434",
  "property-translator": "/property-translator/static-1.5201",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7712",
  "hs-promise-utils": "/hs-promise-utils/static-1.5380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4668",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12793",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5375",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7575",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4262",
  "superstore": "/superstore/static-1.4558",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9932",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7428",
  "hub-http-janus": "/hub-http-janus/static-1.790",
  "hubspotter-http": "/hubspotter-http/static-1.4466",
  "immutable-less": "/immutable-less/static-1.4441",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16310",
  "nav-meta": "/nav-meta/static-1.28869",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10024",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17635",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3663",
  "property-management-common": "/property-management-common/static-1.4572",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8832",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.480",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.392",
  "quartz-head": "/quartz-head/static-1.382",
  "quartz-test": "/quartz-test/static-1.392",
  "quartz-tracking": "/quartz-tracking/static-1.96",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2933",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20257",
  "ContentUtils": "/ContentUtils/static-1.67588",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2272",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38866",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12793",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12930",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13473",
  "ExportDialog": "/ExportDialog/static-6.10175",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40630",
  "reporting-snowflake": "/reporting-snowflake/static-1.55079",
  "reporting-ui-components": "/reporting-ui-components/static-2.63732",
  "reporting-visualizations": "/reporting-visualizations/static-1.58537",
  "ui-addon-teams": "/ui-addon-teams/static-1.21224",
  "magpie-lib": "/magpie-lib/static-1.5381",
  "magpie-types": "/magpie-types/static-1.4841",
  "simple-logging-lib": "/simple-logging-lib/static-1.2837",
  "navigation-components": "/navigation-components/static-1.17232",
  "ai-studio-lib": "/ai-studio-lib/static-1.10967",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10251",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7776",
  "ui-tool-access": "/ui-tool-access/static-1.9933",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7974",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5536",
  "usage-tracker-public": "/usage-tracker-public/static-1.6930",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3405",
  "persist-promise": "/persist-promise/static-1.3493",
  "reference-resolvers": "/reference-resolvers/static-1.7949",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3733",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.127",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2787",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2157",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4857",
  "purchase-motions-components": "/purchase-motions-components/static-1.5465",
  "salesImages": "/salesImages/static-1.520",
  "batch-promise": "/batch-promise/static-1.1336",
  "crm-component-utils": "/crm-component-utils/static-1.38455",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5659",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6658",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7882",
  "navigation-messaging": "/navigation-messaging/static-1.6559",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9449",
  "cms-field-types": "/cms-field-types/static-1.4593",
  "content-icons-ui": "/content-icons-ui/static-1.2149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7035",
  "crm-message-bus": "/crm-message-bus/static-1.42331",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21300",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9612",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4518",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3821",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6563",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.760",
  "onboarding-tours": "/onboarding-tours/static-1.16240",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13002",
  "academy-common-lib": "/academy-common-lib/static-1.12933",
  "content-assistance-lib": "/content-assistance-lib/static-1.7430",
  "dashboard-lib": "/dashboard-lib/static-1.80582",
  "file-manager-components": "/file-manager-components/static-1.22855",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17851",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17575",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17567",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19451",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8479",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4553",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10693",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8814",
  "user-context": "/user-context/static-1.4883",
  "growth-payments-core": "/growth-payments-core/static-1.24697",
  "reporting-plugins": "/reporting-plugins/static-1.9968",
  "reporting-reports": "/reporting-reports/static-1.66139",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.512",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28833",
  "react-codemirror": "/react-codemirror/static-1.10414",
  "apps-service-types": "/apps-service-types/static-1.3665",
  "oauth-service-types": "/oauth-service-types/static-1.4029",
  "onboarding-scopes": "/onboarding-scopes/static-1.6250",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4454",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7480",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14573",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3440",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8526",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2144",
  "purchase-motions-api": "/purchase-motions-api/static-1.5468",
  "signup-constants": "/signup-constants/static-1.18363",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7855",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "card-properties-lib": "/card-properties-lib/static-1.43486",
  "crm-actions": "/crm-actions/static-1.6087",
  "crm-cards-data": "/crm-cards-data/static-1.1186",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42881",
  "customer-data-properties": "/customer-data-properties/static-1.50769",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8778",
  "customer-data-tracking": "/customer-data-tracking/static-1.6668",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3611",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3953",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3505",
  "external-options-client-types": "/external-options-client-types/static-1.3972",
  "react-dnd-compat": "/react-dnd-compat/static-1.4409",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5140",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2858",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1287",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.306",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7313",
  "academy-service-client": "/academy-service-client/static-1.3468",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27913",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8172",
  "video-components-external": "/video-components-external/static-1.10527",
  "video-data-lib": "/video-data-lib/static-1.34185",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8356",
  "payment-link-components": "/payment-link-components/static-1.22911",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9676",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23884",
  "viral-links-lib": "/viral-links-lib/static-1.6821",
  "data-token-picker": "/data-token-picker/static-1.16023",
  "FileManagerLib": "/FileManagerLib/static-1.38495",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5032",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16969",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8238",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.177",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "crm_data": "/crm_data/static-4.91178",
  "crm-links": "/crm-links/static-1.6050",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45385",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14983",
  "crm-fe-perf": "/crm-fe-perf/static-1.22692",
  "calling-global-api": "/calling-global-api/static-1.63615",
  "calling-internal-common": "/calling-internal-common/static-1.31078",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64997",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57291",
  "commerce-products-lib": "/commerce-products-lib/static-1.8829",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.465",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4037",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.420",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47929",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3774",
  "property-value-citations": "/property-value-citations/static-1.1383",
  "pulse": "/pulse/static-1.293",
  "smart-property-lib": "/smart-property-lib/static-1.5865",
  "tiered-pricing": "/tiered-pricing/static-1.811",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10782",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6372",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11413",
  "content-media-compositions": "/content-media-compositions/static-2.15420",
  "media-bridge-lib": "/media-bridge-lib/static-1.18545",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5701",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4874",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3462",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21289",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3632",
  "audio-components": "/audio-components/static-1.5595",
  "FileManagerCore": "/FileManagerCore/static-1.38354",
  "FileManagerImages": "/FileManagerImages/static-1.36006",
  "video-components": "/video-components/static-1.12530",
  "crm_universal": "/crm_universal/static-1.21642",
  "customer-data-email": "/customer-data-email/static-1.17651",
  "calling-error-reporting": "/calling-error-reporting/static-1.31084",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36473",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38829",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18472",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11124",
  "customer-data-content": "/customer-data-content/static-1.26852",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53986",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20841",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17113",
  "project-storage": "/project-storage/static-1.4519",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71131",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5303",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5116",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9534",
  "policy-lib": "/policy-lib/static-1.6572",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10824",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6326",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.211",
  "products-iframe-lib": "/products-iframe-lib/static-1.7281",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9833",
  "directed-graph": "/directed-graph/static-1.724",
  "event-emitter": "/event-emitter/static-1.734",
  "react-tinymce": "/react-tinymce/static-1.54586",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9597",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53712",
  "tinymce-plugins": "/tinymce-plugins/static-1.56826",
  "tinymce-themes": "/tinymce-themes/static-1.55682",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4320",
  "video-embed": "/video-embed/static-1.35019",
  "social-insights-client-types": "/social-insights-client-types/static-1.21291",
  "sequences-lib": "/sequences-lib/static-1.7672",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10134",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17886",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36406",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9763",
  "utility-belt": "/utility-belt/static-1.2329",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21971",
  "products-ui-components": "/products-ui-components/static-1.39348",
  "quotes-client-types": "/quotes-client-types/static-1.37219",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79850",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8883",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6705",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54002",
  "commerce-products-api": "/commerce-products-api/static-1.1940",
  "SafeStorage": "/SafeStorage/static-1.4191",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56060",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101807",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34988",
  "sales-views-client-types": "/sales-views-client-types/static-1.4079",
  "hub-http-contrib": "/hub-http-contrib/static-1.2832",
  "interframe": "/interframe/static-3.4579",
  "tinymce-data": "/tinymce-data/static-1.39797",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5001",
  "layout-dnd-components": "/layout-dnd-components/static-1.12012",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10987",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13831",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8884",
  "outpost": "/outpost/static-1.3993",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7529",
  "customer-data-associations": "/customer-data-associations/static-1.7124",
  "framework-data-table": "/framework-data-table/static-2.11388",
  "customer-data-rte": "/customer-data-rte/static-1.32418",
  "cv-backend-services": "/cv-backend-services/static-1.1500",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5347",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14194",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4899",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7114",
  "commerce-permissions": "/commerce-permissions/static-1.540",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.301",
  "property-description-translator": "/property-description-translator/static-1.3647",
  "FireAlarmUi": "/FireAlarmUi/static-1.4318",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3979",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3450",
  "totals-ui-components": "/totals-ui-components/static-1.22969",
  "ContentData": "/ContentData/static-1.67663",
  "layout-data-lib": "/layout-data-lib/static-1.9312",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1219",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27687",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3625",
  "advanced-menus-core": "/advanced-menus-core/static-1.14796",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11772",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33396",
  "deal-intel-utils": "/deal-intel-utils/static-1.1223",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14795",
  "simple-menus-lib": "/simple-menus-lib/static-1.16312"
}
};
